import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import {
  formatAgeFromMonths,
  formatCurrency,
  getUnitKey
} from '../../used-equipment-helper';

export function UnitList({ units }) {
  if (!units.length) {
    return null;
  }

  return (
    <div className="sui-mt-4">
      <Typography variant="h6" weight="bold">Units at this store</Typography>
      <div className="sui-mt-2 sui-flex sui-flex-col sui-gap-2">
        {units.map((unit) => (
          <div
            key={getUnitKey(unit)}
            className="sui-text-xs sui-text-subtle sui-leading-tight"
          >
            <p>Availability: {unit?.statusCd === 1000 ? 'Available' : 'Unavailable'}</p>
            <p>Unit Number: {unit?.unitNumber || '—'}</p>
            <p>Product Age: {formatAgeFromMonths(unit?.age)}</p>
            {(formatCurrency(unit?.suggestedAmt)
              || formatCurrency(unit?.retailAmt)) && (
              <p>
                {[
                  formatCurrency(unit?.suggestedAmt) ? `Price ${formatCurrency(unit?.suggestedAmt)}` : null,
                  formatCurrency(unit?.retailAmt) ? `Retail ${formatCurrency(unit?.retailAmt)}` : null
                ].filter(Boolean).join(' • ')}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

UnitList.propTypes = {
  units: PropTypes.arrayOf(PropTypes.shape({
    age: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    dateAdded: PropTypes.string,
    minimumAmt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    retailAmt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    statusCd: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    suggestedAmt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unitNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  })).isRequired
};
